var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoBlank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    fill: "white",
    stroke: "#F2C94C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 7.57141H13.41C13.2 6.99141 12.65 6.57141 12 6.57141C11.35 6.57141 10.8 6.99141 10.59 7.57141H8.5C7.95 7.57141 7.5 8.02141 7.5 8.57141V15.5714C7.5 16.1214 7.95 16.5714 8.5 16.5714H15.5C16.05 16.5714 16.5 16.1214 16.5 15.5714V8.57141C16.5 8.02141 16.05 7.57141 15.5 7.57141ZM12 7.57141C12.275 7.57141 12.5 7.79641 12.5 8.07141C12.5 8.34641 12.275 8.57141 12 8.57141C11.725 8.57141 11.5 8.34641 11.5 8.07141C11.5 7.79641 11.725 7.57141 12 7.57141ZM10 14.5714H12.5C12.775 14.5714 13 14.3464 13 14.0714C13 13.7964 12.775 13.5714 12.5 13.5714H10C9.725 13.5714 9.5 13.7964 9.5 14.0714C9.5 14.3464 9.725 14.5714 10 14.5714ZM14 12.5714H10C9.725 12.5714 9.5 12.3464 9.5 12.0714C9.5 11.7964 9.725 11.5714 10 11.5714H14C14.275 11.5714 14.5 11.7964 14.5 12.0714C14.5 12.3464 14.275 12.5714 14 12.5714ZM10 10.5714H14C14.275 10.5714 14.5 10.3464 14.5 10.0714C14.5 9.79641 14.275 9.57141 14 9.57141H10C9.725 9.57141 9.5 9.79641 9.5 10.0714C9.5 10.3464 9.725 10.5714 10 10.5714Z",
    fill: "#F2C94C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlank);
export default __webpack_public_path__ + "static/media/info-blank.f559fb56.svg";
export { ForwardRef as ReactComponent };